<template>
  <button
    type="button"
    class="border-error/8 text-error/87 rounded-lg px-2 py-1 text-sm font-medium"
  >
    <slot> Delete </slot>
  </button>
</template>
